<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import { cn } from '$lib/utils';
  import type { DetailedTestimonialStoryblok } from '$types/bloks';

  export let block: DetailedTestimonialStoryblok;
</script>

{#if block.images}
  <div class="w-full lg:w-7/12 max-w-fit grid gap-2 grid-cols-2 auto-rows-fr">
    {#each block.images as image, i}
      <CmsImage
        image={image.asset}
        class={cn(
          'w-full h-full lg:w-[390px] lg:h-[320px] object-cover rounded-md aspect-[195/166]',
          i === 1 ? 'col-start-2 row-start-3 row-end-7' : 'row-span-4'
        )}
        options={{ size: [390, 0] }}
      />
    {/each}
  </div>
{/if}
